<template>

    <div class="template-cards">

        <div v-touch:swipe.left="actionCard"
             v-touch:swipe.right="actionCard"
             v-touch:swipe.up="actionCard"
             :class="{ 'noselect': card.invalidGrant, 'card-invalid-grant-show': card.invalidGrant && position === 1, 'card-invalid-grant-hide': card.invalidGrant && position !==1 }"
             class="newsletter-container"
             @click="actionCard">

            <div v-if="card.error" class="error-band">

                <p class="error-band-text">{{ $t('cleaning_cards_error_card') }}</p>

            </div>

            <div :class="{ 'card-second': position === 2, 'card-third': position === 3 }" class="card-top">

                <div class="mail-container">

                    <p class="card-mail">{{ card.email }}</p>

                </div>

                <p class="card-title cf-title-2">{{ card.name | capitalizeFirstLetter }}</p>

                <p class="card-subtitle">{{ card.sender }}</p>

            </div>

            <div class="card-bottom">

                <div class="card-bottom-item background-item-1">

                    <img class="card-item-img" src="/img/icons/mailbox.svg">

                    <div>

                        <p class="cf-large-title numbers card-numbers">{{ card.count }}</p>

                        <p class="cf-caption-1 cf-bold item-text">{{ $tc('cleaning_cards_received_emails', card.count) }}</p>

                    </div>

                </div>

                <div class="card-bottom-item background-item-2">

                    <img class="card-item-img" src="/img/icons/eyes-cartoon.svg">

                    <div>

                        <p class="cf-large-title numbers card-numbers">{{ card.openRate }}%</p>

                        <p class="cf-caption-1 cf-bold item-text">{{ $t('cleaning_cards_opening_rate') }}</p>

                    </div>

                </div>


            </div>

            <div v-if="position === 1 && !card.invalidGrant"
                 :class="{
            'overlay-green': throwDirection === 'right',
            'overlay-red': throwDirection === 'left',
            'overlay-orange': throwDirection === 'up'
            }"
                 :style="{opacity: computedOpacity}"
                 class="card-overlay pointer">


                <img :src="computedOverlayImg" class="overlay-img">

                <p class="overlay-text">{{ computedOverlayText }}</p>

            </div>

        </div>

    </div>

</template>

<script>

export default {

    name: 'card-template-newsletters',

    props: {

        card: {
            type: Object,
            default: () => {
            }
        },

        position: {
            type: Number,
            default: 0
        },

        throwDirection: {
            type: String,
            default: ''
        },

        throwOutConfidence: {
            type: Number,
            default: 0
        }

    },

    computed: {

        computedOpacity() {
            return parseFloat(this.throwOutConfidence * 2, 10) < 0.75 ? this.throwOutConfidence * 2 : 0.75
        },

        computedOverlayImg() {
            switch (this.throwDirection) {
                case 'up':
                    return '/img/icons/trash-white.svg'
                case 'left':
                    return '/img/icons/auto-delete-white-2.svg'
                case 'right':
                    return '/img/icons/keep-white.svg'
            }

        },

        computedOverlayText() {
            switch (this.throwDirection) {
                case 'up':
                    return this.$t('cleaning_cards_overlay_delete')
                case 'left':
                    return this.$t('cleaning_cards_overlay_autodelete')
                case 'right':
                    return this.$t('cleaning_cards_overlay_keep')
            }

        }
    },

    methods: {


        actionCard() {
            if (this.card.invalidGrant && this.position === 1) {
                this.$emit('invalidGrant', this.card.email)
            }
        }
    }
}

</script>

<style lang="scss" scoped>


.template-cards {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.card-top {
    min-height: 104px;
    background-color: $blue;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background-image: url('/img/background/wave-cards-mobile.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: contain;
    padding: 16px 24px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: $white;
    @media screen and (min-width: $above-tablet-length) {
        height: 136px;
        padding: 32px 32px 24px;
    }
}

.card-second {
    @media screen and (min-width: $above-tablet-length) {
        background-color: #77beeb;
    }
}

.card-third {
    @media screen and (min-width: $above-tablet-length) {
        background-color: #8fc8ed;
    }
}

.mail-container {
    font-size: 11px;
    line-height: 1.45;
    background-color: $aquamarine;
    height: 24px;
    border-radius: 17px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-mail {
    font-size: 11px;
    line-height: 1.45;
}

.card-title {
    margin-top: 12px;
}

.card-subtitle {
    font-size: 12px;
    line-height: 1.33;
}

.card-bottom {
    background-color: $white;
    display: flex;
    flex-grow: 1;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    padding: 16px 24px;
    justify-content: space-between;
    height: 100%;
    @media screen and (min-width: $above-tablet-length) {
        height: 314px;
    }
}

.error-band {
    position: absolute;
    top: 104px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 32px;
    background-color: $raspberry;
    @media screen and (min-width: $above-tablet-length) {
        top: 135px;
    }
}

.error-band-text {
    font-size: 11px;
    font-weight: 600;
    line-height: 1.45;
    color: $white;
}

.card-bottom-item {
    display: flex;
    flex-grow: 1;
    background-color: $white-light;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 15px 1px;
    width: 50%;
    @media screen and (min-width: $above-tablet-length) {
        max-width: none;
    }
}

.background-item-1 {
    background-image: url('/img/background/cards-wood-1.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: 90%;
    margin-right: 12px;
}

.background-item-2 {
    background-image: url('/img/background/cards-wood-2.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: 90%;
    margin-left: 12px;
}

.card-item-img {
    width: 24px;
    object-fit: contain;
    margin-top: 16px;
    @media screen and (min-width: $above-tablet-length) {
        width: 40px;
    }
}

.item-text {
    color: $grey;
    text-decoration: none;
}

.card-numbers {
    font-size: 40px;
}

.overlay-red {
    background-color: $raspberry;
}

.overlay-orange {
    background-color: $sunset;
}

.overlay-green {
    background-color: $green;
}

.card-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
}

.overlay-img {
    width: 48px;
    object-fit: contain;
}

.overlay-text {
    margin-top: 8px;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.2;
    letter-spacing: -0.2px;
    color: $white;
}

.newsletter-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.card-invalid-grant-show {
    opacity: 0.5;
}

.card-invalid-grant-hide {
    opacity: 0;
}

</style>
